import React, {memo, useCallback, useEffect, useState} from "react"
import "./index.scss"
import iconEdit from "../../assets/images/icons/scenario/scenario-edit.png"
import iconDelete from "../../assets/images/icons/scenario/clear-2.png"
import plusIcon from "../../assets/images/icons/controls/plus.png"
import minusIcon from "../../assets/images/icons/controls/minus.png"
import {toggleScenarioTriggerPopupScreenAction, toggleScenarioTriggerScreenAction} from "../../store/ui/actions"
import {useRPC} from "../../hooks/rpc"
import {useOutsideDetector} from "../../hooks/outside-detector"
import iconCancel from "../../assets/images/icons/alarm/cancel.png"
import iconOK from "../../assets/images/icons/alarm/ok.png"
import {useDispatch, useSelector} from "react-redux"
import {onClickHandler} from "../../utils/onclick"
import {useLocalization} from "../../hooks/localization"
import { useQuestion } from "../../hooks/question"

const RadioButton = memo(function RadioButton({
    isSelected = false,
    title,
    onClick
}: {
    isSelected: boolean
    title: string
    onClick: () => void
}) {
    return (
        <div className="popup-radio-button-container" onClick={onClick}>
            <div className={`popup-radio-pointer ${isSelected ? "popup-radio-selected" : ""}`} />
            <span>{title}</span>
        </div>
    )
})

export const ScenarioTriggerPopupScreen = memo(function ScenarioTriggerPopupScreen() {
    const {t} = useLocalization()
    const dispatch = useDispatch()
    const question = useQuestion();
    const visible = useSelector(state => state.ui.triggerPopupScreen.visible)
    const selectedTrigger = useSelector(state => state.ui.triggerPopupScreen.selectedTrigger)
    const [isPassive, setIsPassive] = useState(selectedTrigger?.is_passive || false)
    const [skipCount, setSkipCount] = useState<number>(selectedTrigger?.skip_count || 0)

    useEffect(() => {
        if (selectedTrigger?.id != null) {
            setIsPassive(selectedTrigger?.is_passive)
            setSkipCount(selectedTrigger?.skip_count)
        }
    }, [selectedTrigger])

    const [rpc] = useRPC()
    const [isDeleting, setDeleting] = useState(false)
    const centerAreaRef = useOutsideDetector(!isDeleting, () => {
        dispatch(toggleScenarioTriggerPopupScreenAction(null))
    })

    const edit = useCallback(() => {
        dispatch(toggleScenarioTriggerScreenAction(selectedTrigger))
        dispatch(toggleScenarioTriggerPopupScreenAction(null))
    }, [selectedTrigger, dispatch])

    const deleteSelected = useCallback(() => {
        setDeleting(true)
        question(t("DO_YOU_CONFIRM"), () => {
            setDeleting(false)
            return rpc.deleteScenarioTrigger(selectedTrigger.id).finally(() => {
                dispatch(toggleScenarioTriggerPopupScreenAction(null))
            })
        },()=> {
            setDeleting(false)
        })
    }, [question, t, selectedTrigger, rpc, dispatch])


    const handleClickSkipCounter = useCallback(
        (type: "decrease" | "increase") => {
            let newValue = skipCount
            switch (type) {
                case "decrease":
                    if (newValue >= 1) {
                        newValue--
                    }
                    break
                case "increase":
                    if (newValue <= 0) {
                        newValue++
                    }
                    break
            }
            setSkipCount(newValue)
            rpc.updateScenarioTrigger({...selectedTrigger, is_passive: isPassive, skip_count: newValue}).catch(
                console.log
            )
        },
        [rpc, selectedTrigger, isPassive, skipCount]
    )

    const handleClickIsPassive = useCallback(() => {
        let newValue = isPassive
        if (newValue) {
            newValue = false
        } else {
            newValue = true
        }
        setIsPassive(newValue)
        rpc.updateScenarioTrigger({...selectedTrigger, is_passive: newValue, skip_count: skipCount}).catch(console.log)
    }, [rpc, selectedTrigger, isPassive, skipCount])

    if (!visible) {
        return null
    }

    return (
        <>
            <div className={"scenario-trigger-screen-wrapper"}>
                <div className="center-area" ref={centerAreaRef}>
                    <div className="skip-count-container">
                        <div
                            className="skip-count-button"
                            {...onClickHandler(() => handleClickSkipCounter("decrease"))}
                        >
                            <img src={minusIcon} alt="" />
                        </div>
                        <span>{skipCount}</span>
                        <div
                            className="skip-count-button"
                            {...onClickHandler(() => handleClickSkipCounter("increase"))}
                        >
                            <img src={plusIcon} alt="" />
                        </div>
                    </div>
                    <span className="p_up-scenario-name">{selectedTrigger.name}</span>
                    <div className="scenario-buttons">
                        <div className="scenario-button" {...onClickHandler(edit)}>
                            <img src={iconEdit} alt="" />
                            {t("EDIT")}
                        </div>
                        <div className="popup-toggle-switch-container">
                            <button  className={`trigger-button-status ${!isPassive ? 't-active' : 't-passive'}`} {...onClickHandler(handleClickIsPassive)}>
                                {!isPassive
                                    ? t("trigger_active")
                                    : t("trigger_passive")}
                            </button>
                        </div>
                        <div className="scenario-button" {...onClickHandler(deleteSelected)}>
                            <img src={iconDelete} alt="" />
                            {t("DELETE")}
                        </div>
                    </div>
                </div>
            </div>
            {/*renderIf(isDeleting)(() => (
                <div className="scenario-screen-wrapper no-background">
                    <div className="center-area darker">
                        <span>
                            <b>
                                {selectedTrigger.name.toUpperCase()} {t("TRIGGER_WILL_BE_DELETED")}
                            </b>
                            <b>{t("DO_YOU_CONFIRM")}</b>
                        </span>
                        <div className="scenario-buttons">
                            <div {...onClickHandler(() => setDeleting(false))} className="scenario-setup-button">
                                <div className="image abort">
                                    <img src={iconCancel} alt="" />
                                </div>
                                <b>{t("CANCEL")}</b>
                            </div>
                            <div {...onClickHandler(deleteSelected)} className="scenario-setup-button">
                                <div className="image set">
                                    <img src={iconOK} alt="" />
                                </div>
                                <b>{t("DELETE")}</b>
                            </div>
                        </div>
                    </div>
                </div>
            ))*/}
        </>
    )
})
